/* eslint-disable no-useless-escape */
export const validEmail = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const validPhone = new RegExp(/^0[2-9][0-9]{7,8}$/i);

export const validNumber = new RegExp(/^[0-9]*$/);

export const validAlphabetAndNumber = new RegExp(/^[A-Za-z0-9]*$/);

export const specialCharacters = new RegExp(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi);

export const validPassword = new RegExp(/^(?=.*[\W_])(?=.*\d)[\w\W]{8,}$/);